module.exports = __webpack_public_path__ + "img/pro_ten_2.294f570e.jpg";